module.exports = __webpack_public_path__ + "img/legendBg.303d25b8.png";